"use client";

interface GridSectionCrosshairsProps {
  /** Article layout uses border-l only (no border-r) — omits the right-edge column. */
  articleLayout?: boolean;
}

/**
 * Crosshair rendering is paused. The per-section design has unresolved
 * alignment/doubling issues (stacked borders, hero overflow-hidden clipping)
 * and the partial state looks worse than no crosshairs.
 *
 * All call sites still mount this component, so re-enabling is a single-file
 * change — restore the implementation from git history.
 */
export function GridSectionCrosshairs(_props: GridSectionCrosshairsProps) {
  return null;
}
